<template>
  <b-card>
    <template #header>
      All Projects logged
      <ProjectCategoryFilter v-if="!isTv" v-model="categoryFilter"
        :defaultCategories="['FiX ', 'MAINT', 'Pipeline', 'T&M']" class="mb-0 ml-1">
      </ProjectCategoryFilter>
      <b-button v-if="!isTv" :variant="tGroupByCategory ? 'success' : 'secondary'" class="btn-sm"
        @click="tGroupByCategory = !tGroupByCategory;">Group by category</b-button>
    </template>
    <div v-if="spinners.contentIsLoading" class="text-center">
      <b-spinner type="grow" variant="primary" />
    </div>
    <div v-else>
      <apexchart width="100%" height="600px" type="heatmap" :options="chartOptionsArea" :series="weekLoad"></apexchart>
    </div>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import clone from 'lodash.clonedeep';
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts';
import statuses from '../../../store/statuses';
import Services from '@/services';
import ProjectCategoryFilter from '@/views/components/jira/ProjectCategoryFilter.vue';
// import vGantt from '@femessage/v-gantt';
// import gantt from '@/views/components/dash/Gantt';

export default {
  mounted() {
    this.getData();
  },
  props: {
  },
  data() {
    return {
      spinners: {
        contentIsLoading: true,
      },
      chartStart: moment().add(-12, 'weeks'),
      issues: [],
      project: [],
      categoryFilter: {},
      categories: [],
      tGroupByCategory: false,

      chartOptionsArea: {
        stroke: {
          width: 1,
        },
        colors: ['#008FFB'],

        dataLabels: {
          formatter: function (val, opts) {
            return val > 0 ? val : '';
          },
        },
        chart: {
          stacked: true,
          animations: {
            enabled: false,
          }
          //  zoom: {
          //   type: 'x',
          //   enabled: true,
          //   autoScaleYaxis: true
          // },
          // toolbar: {
          //   autoSelected: 'zoom'
          // }
        },
        plotOptions: {
          heatmap: {
            radius: 30,
            enableShades: true,
            shadeIntensity: 0.7,
            reverseNegativeShade: true,
            colorScale: {
              ranges: [
                // {
                //   color: '#00ffff'
                // },
                {
                  from: 1,
                  to: 300,
                  color: '#008FFB'
                },
                // {
                //   from: 0,
                //   to: 16,
                //   color: '#008FFB'
                // },
                // {
                //   from: 17,
                //   to: 36,
                //   color: '#00E396'
                // },
                // {
                //   from: 37,
                //   to: 300,
                //   color: '#ff430f'
                // },
              ],
            },

          }
        },
        xaxis: {
          type: 'datetime',
        },
      },
    };
  },
  components: {
    Pagination,
    ProjectCategoryFilter,
    apexchart: VueApexCharts,
  },
  computed: {
    groupByCategory() { return this.isTv || this.tGroupByCategory; },
    ...mapGetters('Auth', ['isTv']),
    ganttIssues() {
      const s = this.chartStart;
      return this.issues.filter((i) => s.isBefore(i.date_started_at) && i.date_started_at.isBefore(moment()));
    },

    chartHeight() {
      return `${this.ganttIssues.length * 18 + 50}px`;
    },
    maxDate() { return moment.max(this.ganttIssues.map((e) => e.date_started_at)); },
    weeks() {
      const s = this.chartStart;
      // Last planned week no more than 24 months ahead
      const e = moment.min(moment(this.maxDate).startOf('week').add(1, 'weeks'), moment(s).add(4 * 24, 'weeks'));
      const weeks = [];
      for (let m = s; m.isBefore(e); m.add(1, 'weeks')) {
        weeks.push(moment(m)); // console.log(m.format('YYYY-MM-DD'));
      }
      return weeks;
    },

    weekLoad() {
      let result = this.ganttIssues;
      if (this.groupByCategory) {
        // group by project cattegories
        result = result.reduce((categories, i) => {
          const category = categories.find((c) => c.category_id === i.project.category_id)
            || { category_id: i.project.category_id, name: this.categories.find((ca) => ca.id === i.project.category_id).name, issues: [] };
          if (!category.issues.length) categories.push(category);
          category.issues.push(i);
          return categories;
        }, []);
      } else {
        // group by projects
        result = result.reduce((projects, i) => {
          const project = projects.find((p) => p.key === i.project.key) || { key: i.project.key, name: i.project.name, category_id: i.project.category_id, issues: [] };
          if (!project.issues.length) projects.push(project);
          project.issues.push(i);
          return projects;
        }, []);
      }
      result = result.filter((p) => this.categoryFilter[p.category_id]);
      result = result.map((p) => {
        return {
          name: p.name,
          data: this.weeks.map((w) => {
            const w2 = moment(w).add(7, 'days');
            const hoursLoadInWeek = p.issues.reduce((hours, i) => {
              return hours + (i.date_started_at.isAfter(w) && i.date_started_at.isBefore(w2) ? i.actuals_time : 0);
            }, 0);
            return {
              x: w.valueOf(),
              // y: Math.round(hoursLoadInWeek / 40 * 10) / 10,
              y: Math.round(hoursLoadInWeek),
            };
          })// .filter(d => d.y > 0)
        };
      });
      return result;
    },

  },
  watch: {
  },
  methods: {
    getData() {
      Services.dash.allProjectDayLogs({ from_date: this.chartStart.format('YYYY-MM-DD') }).then(({ data }) => {
        // console.log(data);
        this.categories = data.categories;
        this.categoryFilter = data.projects.reduce((cats, p) => { cats[p.category_id] = true; return cats; }, {});
        this.issues = data.actuals.map((i) => {
          return {
            ...i,
            project: data.projects.find((p) => p.external_id === i.external_id),
            date_started_at: moment(i.date_started_at),
            actuals_time: i.actuals_time / 3600
          };
        });

        // // this.project = data;
        // // this.project.issues = null;
        this.spinners.contentIsLoading = false;
      });
    }
  }
};
</script>

<style>
ul.tooltipgantt {
  list-style-type: none;
  padding: 1em;
  margin: 0;
}
</style>
